export default __webpack_public_path__ + "static/media/taruLogo.f9331885.png";